import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, Typography, Button } from 'antd';
import { FileTextOutlined, PartitionOutlined, TableOutlined } from '@ant-design/icons';

import MobileMasterDataTopics from './MobileMasterDataTopics';
import MobileMasterDataTopicTradeTables from './MobileMasterDataTopicTradeTables';
import MobileMasterDataLiveFollows from './MobileMasterDataLiveFollows';

const { Text, Title } = Typography;

function MobileMasterData() {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedKey = useMemo(() => {
    try {
      const params = new URLSearchParams(location.search || '');
      return params.get('key') || '';
    } catch (e) {
      return '';
    }
  }, [location.search]);

  const items = useMemo(
    () => [
      { key: 'topics', title: '交易话题', icon: <FileTextOutlined /> },
      { key: 'topic-trade-tables', title: '分表管理', icon: <PartitionOutlined /> },
      { key: 'live-follows', title: '实盘跟随', icon: <TableOutlined /> },
    ],
    []
  );

  if (selectedKey === 'topics') return <MobileMasterDataTopics />;
  if (selectedKey === 'topic-trade-tables') return <MobileMasterDataTopicTradeTables />;
  if (selectedKey === 'live-follows') return <MobileMasterDataLiveFollows />;

  if (selectedKey) {
    return (
      <Card style={{ borderRadius: 10 }} styles={{ body: { padding: 12 } }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <Text strong>提示</Text>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate('/master-data', { replace: true });
            }}
          >
            返回
          </a>
        </div>
        <div style={{ marginTop: 10 }}>
          <Text type="secondary">移动端不展示该功能，请在桌面端使用。</Text>
        </div>
      </Card>
    );
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 16px 12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
            主数据
          </Title>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="small"
              onClick={() => navigate('/', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              首页
            </Button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: 12,
            marginTop: 16,
          }}
        >
          {items.map((it) => (
            <Card key={it.key} hoverable onClick={() => navigate(`/master-data?key=${encodeURIComponent(it.key)}`)} style={{ borderRadius: 10, cursor: 'pointer' }} styles={{ body: { padding: 16, textAlign: 'center' } }}>
              <div style={{ fontSize: 32, color: '#1677ff', marginBottom: 12 }}>{it.icon}</div>
              <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 8 }}>{it.title}</div>
              <div style={{ color: '#666', fontSize: 12, lineHeight: 1.4 }}>
                {it.key === 'topics' && '管理交易话题和同步配置'}
                {it.key === 'topic-trade-tables' && '管理话题分表和配置'}
                {it.key === 'live-follows' && '管理实盘跟随配置'}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MobileMasterData;
